if (!customElements.get('learn-dosing-video')) {
  class LearnDosingVideo extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-learn-dosing-play]');
      if (!this.button) return;
      this.onPlay = this.onPlay.bind(this);
      this.button.addEventListener('click', this.onPlay);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onPlay);
    }

    onPlay() {
      const template = this.querySelector('template[data-learn-dosing-template]');
      if (!template) return;

      this.appendChild(template.content.cloneNode(true));
      this.classList.add('is-playing');

      const media = this.querySelector('video, iframe');
      if (media) media.focus();
    }
  }

  customElements.define('learn-dosing-video', LearnDosingVideo);
}
